import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";

import globalColors from "../styles/globalColors";

export default (props: {
  label: string | undefined;
  containerStyles?: any;
}) => {
  const { label, containerStyles } = props;
  return <div css={[styles.badge, containerStyles]}>{label}</div>;
};

const styles = {
  badge: {
    color: globalColors.white,
    backgroundColor: globalColors.textBlue,
    padding: "5px 15px",
    borderRadius: 21,
    fontSize: 12
  }
};
